export var inAppNotificationStatusType;
(function (inAppNotificationStatusType) {
    inAppNotificationStatusType["Unread"] = "Unread";
    inAppNotificationStatusType["Read"] = "Read";
})(inAppNotificationStatusType || (inAppNotificationStatusType = {}));
export var timeFilterOptionType;
(function (timeFilterOptionType) {
    timeFilterOptionType[timeFilterOptionType["Custom"] = -1] = "Custom";
})(timeFilterOptionType || (timeFilterOptionType = {}));
